export default __webpack_public_path__ + "static/media/Emotional05.41761da9.png";